// Calls `cb` after the window `load` event, then on an idle slot (≤ 2 s). Returns a cancel function.
export const afterLoadIdle = (cb) => {
  let alive = true;
  const idle = () => { if (!alive) return; const ric = window.requestIdleCallback ? (f) => window.requestIdleCallback(f, { timeout: 2000 }) : (f) => setTimeout(f, 200); ric(() => alive && cb()); };
  if (document.readyState === "complete") idle(); else window.addEventListener("load", idle, { once: true });
  return () => { alive = false; window.removeEventListener("load", idle); };
};
